import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import "./BottomSearchSheet.scss";
import { Calendar } from "react-date-range";
import PassengerSelection from "../../../../PassengerSelection";

const BottomSearchSheet = (props) => {
  const { show, setShowSearchSheet, state } = props;
  return (
    <BottomSheet
      open={show}
      onDismiss={() => setShowSearchSheet(false)}
      className="priceBreakdown__bottomSheetMain"
    >
      <div className="bottom-sheet">
        {show === "city" && (
          <>
            <div className="bottom-sheet__title">
              Search for country and stays
            </div>
            <div className="bottom-sheet__search">
              <input
                placeholder="Where from"
                value={
                  state.selectedHotel?.hotel_name || state?.destinationCity
                }
                onChange={(e) => {
                  props.searchDestinations(e);
                }}
              />
              {state?.tempHotelList?.length > 0 && (
                <div className="stay-search-main__fields__col1__results">
                  {state.tempHotelList.map((item, index) => (
                    <div
                      className={`stay-search-main__fields__col1__results__row ${
                        index !== state.tempHotelList?.length - 1 &&
                        "stay-search-main__fields__col1__results__row__mb"
                      }`}
                      onClick={() => {
                        props.setState({
                          ...state,
                          destinationCity: item.city_name,
                          destinationCountry: item.country_name,
                          selectedHotel: item?.hotel_name ? item : {},
                          tempHotelList: [],
                        });
                        setShowSearchSheet(false);
                      }}
                    >
                      <div className="stay-search-main__fields__col1__results__row__col1">
                        <img
                          src={item.thumbnail || item.thumbnail_image}
                          alt="thumbnail"
                        />
                      </div>
                      <div className="stay-search-main__fields__col1__results__row__col2">
                        <div className="stay-search-main__fields__col1__results__row__col2__txt1">
                          {item.hotel_name || item.city_name}
                        </div>
                        <div className="stay-search-main__fields__col1__results__row__col2__txt2">
                          {item.country_name}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
        {show === "checkin" && (
          <div className="stay-search-main__fields__col2">
            <div className="bottom-sheet__title">Select Check-In</div>
            <Calendar
              onChange={(range) => {
                props.setState({ ...state, start_date: range });
                setShowSearchSheet("");
              }}
              minDate={new Date()}
              date={state.start_date}
              months={state.isMobile ? 1 : 1}
              preventSnapRefocus={true}
              direction="horizontal"
            />
          </div>
        )}
        {show === "checkout" && (
          <div className="stay-search-main__fields__col2">
            <div className="bottom-sheet__title">Select Check-Out</div>
            <Calendar
              onChange={(range) => {
                props.setState({ ...state, end_date: range });
                setShowSearchSheet("");
              }}
              minDate={new Date(state.start_date)}
              date={state.end_date}
              months={state.isMobile ? 1 : 1}
              preventSnapRefocus={true}
              direction="horizontal"
            />
          </div>
        )}
        {show === "passenger" && (
          <div className="stay-search-main__fields__col4">
            <div className="bottom-sheet__title">Add passengers</div>
            <PassengerSelection
              state={state}
              onClose={() => setShowSearchSheet("")}
              setState={props.setState}
              applyQty={props.applyQty}
              onChangeChildAge={[1, 2, 3]}
            />
          </div>
        )}
      </div>
    </BottomSheet>
  );
};

export default BottomSearchSheet;
